import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import useStyles from './styles';
import Waffle from '../Charts/Waffle';

import TranslationTxt from '../TranslationTxt/TranslationTxt';

const WaffleSection = () => {
  const colorbyMeasures = [
    {
      measure: 'Gender - 2022',
      legends: [
        {
          legend: 'Only({<Index = {10}>}[$(vLanguage)])',
          color: '#9EBFCE',
        },
        {
          legend: 'Only({<Index = {9}>}[$(vLanguage)])',
          color: '#BE7999',
        },
        {
          legend: 'Only({<Index = {11}>}[$(vLanguage)])',
          color: '#204635',
        },
      ],
    },
    {
      measure: 'Race - 2022',
      legends: [
        {
          legend: 'Only({<Index = {20}>}[$(vLanguage)])',
          color: '#A7A4D4',
        },
        {
          legend: 'Only({<Index = {26}>}[$(vLanguage)])',
          color: '#C17A82',
        },
        {
          legend: 'Only({<Index = {27}>}[$(vLanguage)])',
          color: '#408CA0',
        },
        {
          legend: 'Only({<Index = {28}>}[$(vLanguage)])',
          color: '#4CDBD7',
        },
        {
          legend: 'Only({<Index = {29}>}[$(vLanguage)])',
          color: '#A55886',
        },
        {
          legend: 'Only({<Index = {30}>}[$(vLanguage)])',
          color: '#E8CEAA',
        },
        {
          legend: 'Only({<Index = {32}>}[$(vLanguage)])',
          color: '#A2C3B4',
        },
        // {
        //   legend: 'Unknown',
        //   color: '#BFBFBF50',
        // },
      ],
    },
    {
      measure: 'Job Role - 2022',
      legends: [
        {
          legend: 'Only({<Index = {14}>}[$(vLanguage)])',
          color: '#24796C',
        },
        {
          legend: 'Only({<Index = {13}>}[$(vLanguage)])',
          color: '#CDB3A2',
        },
        {
          legend: 'Only({<Index = {15}>}[$(vLanguage)])',
          color: '#2F8AC4',
        },
        {
          legend: 'Only({<Index = {16}>}[$(vLanguage)])',
          color: '#B890D3',
        },
      ],
    },
  ];

  const [mix, setMix] = useState('Race - 2022');
  const [color, setColor] = useState('Race - 2022');
  const [showLegend, setShowLegend] = useState(false);

  const handleMixChange = (event) => {
    setMix(event.target.value);
    if (event.target.value !== color) {
      setShowLegend(true);
    } else {
      setShowLegend(false);
    }
  };

  const handleColorChange = (event) => {
    setColor(event.target.value);
    if (event.target.value !== mix) {
      setShowLegend(true);
    } else {
      setShowLegend(false);
    }
  };

  const classes = useStyles();
  return (
    <div className="section" style={{ marginBottom: 120, marginTop: 50 }}>
      <Box className={classes.filter}>
        <Box className={classes.filterBy}>
          <Typography variant="body1" className={classes.toggleText}>
            <TranslationTxt measure="=Only({<Index = {21}>}[$(vLanguage)])" />
          </Typography>
          <FormControl className={classes.formControl}>
            <Select
              value={mix}
              onChange={handleMixChange}
              className={classes.select}
              IconComponent={KeyboardArrowDownOutlinedIcon}

            >
              <MenuItem value="Race - 2022">
                <TranslationTxt measure="=Only({<Index = {22}>}[$(vLanguage)])" />
              </MenuItem>
              <MenuItem value="Gender - 2022">
                <TranslationTxt measure="=Only({<Index = {23}>}[$(vLanguage)])" />
              </MenuItem>
              <MenuItem value="Job Role - 2022">
                <TranslationTxt measure="=Only({<Index = {24}>}[$(vLanguage)])" />
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box className={classes.filterBy}>
          <Typography variant="body1" className={classes.toggleText}>
            <TranslationTxt measure="=Only({<Index = {25}>}[$(vLanguage)])" />
          </Typography>
          <FormControl className={classes.formControl}>
            <Select
              value={color}
              onChange={handleColorChange}
              className={classes.select}
              IconComponent={KeyboardArrowDownOutlinedIcon}

            >
              <MenuItem value="Race - 2022">
                <TranslationTxt measure="=Only({<Index = {22}>}[$(vLanguage)])" />
              </MenuItem>
              <MenuItem value="Gender - 2022">
                <TranslationTxt measure="=Only({<Index = {23}>}[$(vLanguage)])" />
              </MenuItem>
              <MenuItem value="Job Role - 2022">
                <TranslationTxt measure="=Only({<Index = {24}>}[$(vLanguage)])" />
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Box className={classes.legendWrapper}>
        {showLegend
        && (
        <Box className={classes.legends}>
          {
            colorbyMeasures.filter((m) => m.measure === color)[0].legends.map((l) => (
              <Box className={classes.legend} key={l.legend}>
                <div className={classes.legendColor} style={{ backgroundColor: l.color }} />
                <Typography className={classes.legendText}>
                  <TranslationTxt measure={l.legend} />
                </Typography>
              </Box>
            ))
          }
        </Box>
        )}
      </Box>
      <Waffle mix={mix} color={color} />
    </div>
  );
};

export default WaffleSection;
